import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatDialogModule } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatMenuModule } from "@angular/material/menu";
import { MatSelectModule } from "@angular/material/select";
import { MatTabsModule } from "@angular/material/tabs";
import { MatToolbarModule } from "@angular/material/toolbar";
import { FuseSidebarModule } from "@fuse/components";
import { FuseSharedModule } from "@fuse/shared.module";
import { MatCarouselModule } from "@ngmodule/material-carousel";
import { TranslateModule } from "@ngx-translate/core";
import { S3File } from "app/helper-components/S3File";
import { S3Image } from "app/helper-components/S3Image";
import { TopSearchBarComponent } from "app/helper-components/top-search-bar/top-search-bar.component";
import { AlertsNotificationComponent } from "app/main/alerts-notification/alerts-notification.component";
import { AddBoothComponent } from "app/main/edit-event/add_booth/add_booth.component";
import { EventFinanceCardComponent } from "app/main/events/event-card/event-finance-card/event-finance-card.component";
import { EventNormalCardComponent } from "app/main/events/event-card/event-normal-card/event-normal-card.component";
import { EventTheermanamCardComponent } from "app/main/events/event-card/event-theermanam-card/event-theermanam-card.component";
import { ImageSliderComponent } from "app/main/image-slider/image-slider.component";
import { ResultComponent } from "app/main/result/result.component";
import { UripinarComponent } from "app/main/uripinar/uripinar.component";
import { LoadingPlaceHolderComponent } from "../helper-components/loading-placeholder/loading-placeholder.component";
import { PlainTextDialog } from "../main/plain-text-dialog/plain-text-dialog.component";
import { BarracksFilter } from "../pipes/barracks-filter.pipe";
import { EventOrganizer, EventPlace } from "../pipes/events.pipe";
import { IterablePipe } from "../pipes/iterable.pipe";
import { MonthTranslate } from "../pipes/month-translate.pipe";
import { S3ImagePipe } from "../pipes/s3.image.pipe";
import { SafeHtml } from "../pipes/safe-html.pipe";
import { SearchPipe } from "../pipes/search.pipe";
import { CreateCardModalComponent } from "./createCard-modal/createCard-modal.component";
import { EditModalComponent } from "./edit-modal/edit-modal.component";
import { MovePanchayatComponent } from "./movePanchayat-modal/movePanchayat.component";
import { AddVacanciesComponent } from './party-person-card/add-vacancies/add-vacancies.component';
import { PartyPersonEmptyCardComponent } from "./party-person-card/party-person-empty-card.component";
import { TheermanamSelectionSheet } from "./party-person-card/theermanam-selection-sheet/theermanam-selection-sheet.component";

@NgModule({
  imports: [
    CommonModule,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatSelectModule,
    FuseSharedModule,
    FuseSidebarModule,
    MatDialogModule,
    TranslateModule,
    MatMenuModule,
    MatCardModule,
    MatCarouselModule,
    MatToolbarModule,
    MatTabsModule,
    MatDatepickerModule,
    FormsModule,
    ReactiveFormsModule
  ],
  declarations: [
    TopSearchBarComponent,
    AlertsNotificationComponent,
    S3Image,
    S3File,
    BarracksFilter,
    EventPlace,
    EventOrganizer,
    S3ImagePipe,
    MonthTranslate,
    IterablePipe,
    LoadingPlaceHolderComponent,
    SafeHtml,
    EditModalComponent,
    MovePanchayatComponent,
    EventNormalCardComponent,
    EventTheermanamCardComponent,
    EventFinanceCardComponent,
    ImageSliderComponent,
    TheermanamSelectionSheet,
    PartyPersonEmptyCardComponent,
    AddBoothComponent,
    UripinarComponent,
    ResultComponent,
    PlainTextDialog,
    CreateCardModalComponent,
    SearchPipe,
    AddVacanciesComponent
  ],
  exports: [
    TopSearchBarComponent,
    AlertsNotificationComponent,
    S3Image,
    S3File,
    BarracksFilter,
    EventPlace,
    EventOrganizer,
    S3ImagePipe,
    MonthTranslate,
    IterablePipe,
    LoadingPlaceHolderComponent,
    SafeHtml,
    EditModalComponent,
    EventNormalCardComponent,
    EventTheermanamCardComponent,
    EventFinanceCardComponent,
    ImageSliderComponent,
    PlainTextDialog,
    CreateCardModalComponent,
    SearchPipe,
  ],
})
export class SharedModule { }
